import { rem } from 'polished';
import { medium, small } from '@unmind/design-system';
import styled, { css } from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-bottom: ${rem(36)};
  padding-left: ${rem(24)};
  padding-right: ${rem(24)};

  ${small(css`
    padding-left: ${rem(32)};
    padding-right: ${rem(32)};
  `)}

  ${medium(css`
    padding-left: ${rem(40)};
    padding-right: ${rem(40)};
  `)}
`;
